import React, { useEffect, useState } from "react";
import { APP_VERSION, APP_BUILD_TIME, serverUrl } from "@/config/default";

const VersionInfo = () => {
  const [apiVersion, setApiVersion] = useState<string | null>(null);
  const [error, setError] = useState("");
  useEffect(() => {
    const controller = new AbortController();
    let active = true;
    const timeout = window.setTimeout(() => {
      if (active) setError("API не ответил за 8 секунд");
      controller.abort();
    }, 8000);
    (async () => {
      try {
        let response = await fetch(`${serverUrl}version`, { signal: controller.signal, cache: "no-store" });
        // Старые сборки отвечали версией только на корневом маршруте.
        if (response.status === 404) response = await fetch(serverUrl, { signal: controller.signal, cache: "no-store" });
        if (!response.ok) throw new Error(`API: HTTP ${response.status}`);
        const data = await response.json();
        if (typeof data.version !== "string") throw new Error("API не сообщает версию сборки");
        if (active) setApiVersion(data.version);
      } catch (err) {
        if (active && !controller.signal.aborted) setError("API недоступен: проверьте запуск сервера и CORS");
      } finally { window.clearTimeout(timeout); }
    })();
    return () => { active = false; window.clearTimeout(timeout); controller.abort(); };
  }, []);

  return <div className="version" title={`Сборка фронта: ${APP_BUILD_TIME}. API: ${serverUrl}. ${error}`}>
    Фронт v{APP_VERSION} · {error ? "API недоступен" : apiVersion ? `API v${apiVersion}` : "Проверка API…"}
    {apiVersion && apiVersion !== APP_VERSION && " · версии различаются"}
  </div>;
};

export default VersionInfo;
